import { parseResponseBody, prepareBody, requestSocketPromiseWithTimeout } from "../../socket/query"
import * as SERVICE from "../../constants/service.types"

/**
 * Returns camera list
 */
export const listStateDevice = async ({ serials, namespace }) => {
  const response = await requestSocketPromiseWithTimeout({
    appServiceType: SERVICE.LIST_STATE_DEVICES,
    body: prepareBody({
      serials,
      namespace,
    }),
  })

  return parseResponseBody(response);
}
